import { useEffect, useState } from "react";

export default function DebugHierarchy() {
  const [state, setState] = useState({ loading: true, cached: null, count: 0, sample: null, error: null });

  useEffect(() => {
    (async () => {
      try {
        const base = process.env.REACT_APP_API_BASE || "http://localhost:5050";
        const res = await fetch(`${base}/api/hierarchy/conference`);
        const json = await res.json();
        setState({
          loading: false,
          cached: json.cached ?? null,
          count: Array.isArray(json.data) ? json.data.length : 0,
          sample: Array.isArray(json.data) ? json.data.slice(0, 2) : null,
          error: null,
        });
      } catch (e) {
        setState({ loading: false, cached: null, count: 0, sample: null, error: String(e) });
      }
    })();
  }, []);

  if (state.loading) return <div style={{ padding: 16 }}>Loading…</div>;
  if (state.error) return <div style={{ padding: 16, color: "red" }}>Error: {state.error}</div>;

  return (
    <div style={{ padding: 16 }}>
      <h1>Hierarchy Debug</h1>
      <div><b>cached:</b> {String(state.cached)}</div>
      <div><b>count:</b> {state.count}</div>
      <pre>{JSON.stringify(state.sample, null, 2)}</pre>
    </div>
  );
}
